import { isNumber, sumBy } from 'lodash';

import { Math } from 'classes';
import { P2PProvider, PayinOrder } from 'types';
import { intervalCommissionsUtils } from 'utils';

export type ReassignmentFees = {
  providerFee: number;
  agentsFee: number;
  shopCommission: number;
  unprofitable: boolean;
};

// Reassignment completes the order even when the new provider makes it unprofitable
// (the platform takes the loss), so the operator is warned in advance. The order keeps the original
// provider's rates on reassignment and only the fee changes, so the fees are what is compared.
export const getReassignmentFees = (
  order: Pick<PayinOrder, 'amount' | 'initialShopCommission' | 'initialAgents'>,
  provider: Partial<Pick<P2PProvider, 'payinConfig'>> | undefined,
  intervalCommissionsEnabled: boolean,
): ReassignmentFees | null => {
  if (
    !isNumber(provider?.payinConfig?.expectedFee) ||
    !isNumber(order.initialShopCommission)
  ) {
    return null;
  }
  // same amount the backend uses to pick the provider's interval commission on reassignment
  const providerFee = intervalCommissionsUtils.getProviderExpectedFeePercent(
    order.amount,
    provider?.payinConfig,
    intervalCommissionsEnabled,
  );
  const agentsFee = sumBy(
    order.initialAgents,
    (agent) => agent.payinCompensationPercentage || 0,
  );
  const shopCommission = order.initialShopCommission;
  return {
    providerFee,
    agentsFee,
    shopCommission,
    unprofitable: new Math(providerFee).plus(agentsFee).value > shopCommission,
  };
};
